import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spinner } from "@/components/ui/Spinner";
import { normGroups } from "@/lib/acl";
import { useCurrentUser } from "@/lib/auth";
import { useBestellwesenNavigationWithUser } from "@/lib/bestellwesenNav";
import { BestellwesenNav } from "@/pages/bestellwesen/BestellwesenNav";
import { useMemo } from "react";

export function BestellwesenLayout() {
  const location = useLocation();
  const { user } = useCurrentUser();
  const groups = useMemo(() => normGroups((user?.groups as string[] | undefined) ?? []), [user]);
  const { visibleItems, showSidebar, monteurMaterialOnly, loading } =
    useBestellwesenNavigationWithUser(groups);

  if (loading) {
    return (
      <div className="flex justify-center py-16">
        <Spinner />
      </div>
    );
  }

  if (monteurMaterialOnly) {
    const path = location.pathname.replace(/\/$/, "");
    if (path === "/bestellwesen" || path.endsWith("/bestellwesen/uebersicht")) {
      return <Navigate to="/materialanforderungen" replace />;
    }
  }

  if (!showSidebar) {
    return <Outlet />;
  }

  return (
    <div className="eh-bestellwesen-page-shell">
      <BestellwesenNav items={visibleItems} />
      <div className="eh-project-page-main">
        <Outlet />
      </div>
    </div>
  );
}
